import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { paginationActions } from '../../store/actions'
import moment from 'moment'

const Pagination = (props) => {
  const { pagination, pagesToShow, currentPage } = props

  // console.log("pagesToShow : "+pagesToShow)

  const [state, setState] = useState({
    totalRecords: props.totalRecords,
    currentPage,
  })

  useEffect(() => {
    setState({ ...state, currentPage })
  }, [currentPage])

  {
    /*var pagesToShow = 10
     */
  }

  var startFromNumber = 1
  var pages = []

  for (let i = 1; i <= Math.ceil(props.totalRecords / (pagesToShow ? pagesToShow : 10)); i++) {
    pages.push(startFromNumber++)
  }

  const handlePage = (page) => {
    setState({
      ...state,
      currentPage: page,
    })
    props.onChange(page)
  }

  return (
    <React.Fragment>
      <div className="pagination">
        <ul>
          {pages.map((page, index) => (
            <li key={index} className={(state.currentPage ? state.currentPage : 1) === page ? 'active' : ''}>
              <a onClick={() => handlePage(page)}>{page}</a>
            </li>
          ))}
        </ul>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    pagination: state.pagination,
  }
}

const actionCreators = {
  setPage: paginationActions.setPage,
}

export default connect(mapStateToProps, actionCreators)(Pagination)
